import React, { useState } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import { useSearchEmployees } from '~/hooks/apis/business-traveller/useSearchEmployees';

interface Props {
  businessId: string;
  label: string;
  value: App.BusinessEmployee | null;
  onChange: (employee: App.BusinessEmployee | null) => void;
  disabled?: boolean;
  /** Search text the field starts with, such as the traveller's email from the PNR. */
  initialSearch?: string;
}

const employeeLabel = (employee: App.BusinessEmployee) =>
  `${employee.firstName} ${employee.lastName} (${employee.email})`;

export default function BusinessEmployeeSelect({ businessId, label, value, onChange, disabled, initialSearch }: Props) {
  const [search, setSearch] = useState(initialSearch ?? '');
  const { data, isFetching } = useSearchEmployees(businessId, search);

  return (
    <Autocomplete
      size="small"
      options={data?.result ?? []}
      value={value}
      onChange={(_event, employee) => onChange(employee)}
      inputValue={search}
      onInputChange={(_event, text) => setSearch(text)}
      getOptionLabel={employeeLabel}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      filterOptions={(options) => options}
      loading={isFetching}
      disabled={disabled || !businessId}
      noOptionsText="Search by employee name or email"
      sx={{ flex: 1, minWidth: 320 }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
}
